/**
 * Configuración global de la aplicación.
 * Centraliza aquí los textos/valores fijos para no repetirlos por el código.
 */
export const config = {
  appName: "Sureste Capital Seguimiento y Control",
  companyName: "Sureste Capital de Poniente",
  tagline: "Gestión de dispositivos",
  realm: "Sureste",
} as const;

// Lee una env numérica. Vacía/ausente/no numérica -> valor por defecto. Ojo: `Number("")` es 0
// (no NaN), así que el vacío se descarta ANTES de convertir; si no, un .env sin valor mandaría
// los mapas al golfo de Guinea [0,0] en vez de caer al defecto.
function envNum(valor: string | undefined, porDefecto: number): number {
  const t = valor?.trim();
  if (!t) return porDefecto;
  const n = Number(t);
  return Number.isFinite(n) ? n : porDefecto;
}

/**
 * Centro por defecto de los mapas: dónde encuadran cuando no hay nada que mostrar (flota sin
 * posiciones, recorrido sin puntos, geofence nueva). Configurable por entorno desde el `.env`;
 * si falta, cae a la zona de Almería (donde está la flota).
 *
 * `NEXT_PUBLIC_*` porque los mapas son componentes cliente ("use client") y no pueden leer
 * `process.env` en el navegador: Next inyecta estas dos al compilar. Por eso hay que
 * referenciarlas de forma LITERAL (nunca `process.env[nombre]`) y **reiniciar el contenedor**
 * del frontend para que un cambio en el `.env` surta efecto.
 */
export const MAPA_CENTRO: [number, number] = [
  envNum(process.env.NEXT_PUBLIC_MAPA_LAT, 36.83),
  envNum(process.env.NEXT_PUBLIC_MAPA_LON, -2.46),
];
